import {Component} from 'panel';

type ComponentConstructor = new (...args: any[]) => Component<any, any, any, any, any, any>;

export function withStylesPanel<T extends ComponentConstructor>(panelComponent: T, stylesCss: string): T {
  const TempClass = class extends panelComponent {
    connectedCallback() {
      super.connectedCallback();
      this.applyStaticStyle(stylesCss);
    }
  };
  return TempClass as T;
}
